import React, {forwardRef} from 'react';

import {AppContext} from '../../AppModule/Context';
import {ROOT} from '../../components/expertDashboardModule/expertSettingsComponent/leftNavigationData';

import expertHomeService from '../../services/expertHomeService';
import navigationService from '../../services/navigationService';
import storageService from '../../services/storageService';
import VIDABOO_CONSTANTS from '../../config/consts';

export const ThisContext = React.createContext();

class ExpertHomeContextProvider extends React.Component {
  constructor() {
    super();
    this.state = {
      privateChatRoomDto: {},
      chatRoomIdOfActiveCall: null,
      userProfilePhotoUrl: null,
      accountProfilePhotoUrl: null,
      widgetDtos: null, // [widgetDto1, widgetDto2]
      selectedMentorDtos: null, // {{mentorId1: widgetDto1}, {mentorId2: widgetDto2}}
      // selectedTeamMentorDtos: null, // {{mentorId1: widgetDto1}, {mentorId2: widgetDto2}}
      rootNavElement: ROOT,
      activeNavElement: null,
      showMentorPills: JSON.parse(
        storageService.getItem(
          VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.MENTOR_PILLS_VISIBLE,
        ) ?? true,
      ),
      showWidgetSelectorDD: false,
      backOfficeConfiguration: null,
      expertSettingsTabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
      avoidFrillAutoload: false,
      showFullBackOfficeSettingsBtn: false,
      activeTourComponent: null,
      marketingElementsStatus:
        expertHomeService.createNewMarketingElementsStatus(),
      nativeFlagWidgetVisibilityType:
        VIDABOO_CONSTANTS.NATIVE_FLAG_WIDGET_VISIBILITY_TYPES.BOTTOM_RIGHT,
    };
  }

  setAvoidFrillAutoload = (avoidFrillAutoload) => {
    this.setState({avoidFrillAutoload});
  };
  setActiveTourComponent = (activeTourComponent) => {
    this.setState({activeTourComponent});
  };
  setMarketingElementsStatus = (marketingElementType, newStatus) => {
    const marketingElementsStatus = {...this.state.marketingElementsStatus};
    marketingElementsStatus[marketingElementType] = newStatus;
    this.setState({marketingElementsStatus});
  };
  setPrivateChatRoomDto = (privateChatRoomDto) => {
    this.setState({privateChatRoomDto});
  };
  setChatRoomIdOfActiveCall = (chatRoomIdOfActiveCall) => {
    this.setState({chatRoomIdOfActiveCall});
  };

  setUserProfilePhotoUrl = (userProfilePhotoUrl) => {
    this.setState({userProfilePhotoUrl});
  };

  setAccountProfilePhotoUrl = (accountProfilePhotoUrl) => {
    this.setState({accountProfilePhotoUrl});
  };

  setWidgetDtos = (widgetDtos) => {
    this.setState({widgetDtos});
  };

  setSelectedMentorDtos = (selectedMentorDtos) => {
    this.setState({selectedMentorDtos});
  };

  // setSelectedTeamMentorDtos = (selectedTeamMentorDtos) => {
  //   this.setState({selectedTeamMentorDtos});
  // };

  setActiveNavElement = (activeNavElement) => {
    this.setState({activeNavElement});
  };

  setNativeFlagWidgetVisibility = (visibilityType) =>
    this.setState({nativeFlagWidgetVisibilityType: visibilityType});

  getFirstMentorDtoByWidgetAndUserId = (widgetId, userId) => {
    const widgetDto = this.getWidgetDtoByWidgetId(widgetId);

    return Object.values(widgetDto?.mentorsControlMapDto ?? {}).find(
      (widgetMentorCtrlDto) =>
        widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
        userId,
    );
  };

  getFirstSelectedMentorDtoByWidgetAndUserId = (widgetId, userId) => {
    const widgetDto = this.getWidgetDtoByWidgetId(widgetId);

    return Object.values(widgetDto?.mentorsControlMapDto ?? {}).find(
      (widgetMentorCtrlDto) =>
        widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
          userId &&
        this.state.selectedMentorDtos[
          widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId
        ],
    );
  };

  getFirstSelectedWidgetMentorCtrlDtoUsingUserId = (userId) => {
    let widgetMentorCtrlDto = null;
    for (const mentorId in this.state.selectedMentorDtos ?? {}) {
      if (
        !widgetMentorCtrlDto &&
        this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
          ?.extendedMentorDto.mentorDto.mentorOwnerId === userId
      ) {
        widgetMentorCtrlDto =
          this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[
            mentorId
          ];
      }
    }
    return widgetMentorCtrlDto;
  };

  getSelectedMentorDto = () => {
    const mentorId = Object.keys(this.state.selectedMentorDtos || {})[0];
    if (mentorId) {
      return this.state.selectedMentorDtos[mentorId]?.mentorsControlMapDto[
        mentorId
      ]?.extendedMentorDto?.mentorDto;
    } else {
      return null;
    }
  };

  getSelectedTeamMentorDto = () => {
    const teamMentorId = Object.keys(
      this.state.selectedTeamMentorDtos ?? {},
    )[0];
    if (teamMentorId) {
      return this.state.selectedTeamMentorDtos[teamMentorId]?.teamMentorsMapDto[
        teamMentorId
      ]?.extendedMentorDto?.mentorDto;
    } else {
      return null;
    }
  };

  getSelectedWidgetDto = () => {
    return Object.values(this.state.selectedMentorDtos || {})[0];
  };

  getSelectedTeamWidgetDto = () => {
    return Object.values(this.state.selectedTeamMentorDtos || {})[0];
  };

  getWidgetDtoByMentorId = (mentorId) => {
    let result = {};
    this.state.widgetDtos?.forEach((widgetDto) => {
      if (widgetDto.mentorsControlMapDto[mentorId]) {
        result = widgetDto;
      }
    });
    return result;
  };

  getWidgetDtoByTeamMentorId = (teamMentorId) => {
    let result = {};
    this.state.widgetDtos?.forEach((widgetDto) => {
      if (widgetDto.teamMentorsMapDto[teamMentorId]) {
        result = widgetDto;
      }
    });
    return result;
  };

  getSelectedWidgetMentorCtrlDto = () => {
    const mentorId = Object.keys(this.state.selectedMentorDtos || {})[0];
    if (mentorId) {
      return this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[
        mentorId
      ];
    } else {
      return null;
    }
  };

  getAuthorizedSelectedMentorIds = (includeTeamMentorIds) => {
    let mentorIds = [];
    const selectedMentorDtos = this.state.selectedMentorDtos || {};
    for (const mentorId in selectedMentorDtos) {
      if (
        selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
          ?.extendedMentorDto?.privateDataConsentStatus ===
        VIDABOO_CONSTANTS.PRIVATE_DATA_ACCESS_STATES.GRANTED
      ) {
        mentorIds.push(mentorId);
      }
    }
    if (includeTeamMentorIds) {
      const authorizedTeamMentorIds = this.getAuthorizedSelectedTeamMentorIds();
      mentorIds = [...mentorIds, ...authorizedTeamMentorIds];
    }
    return mentorIds;
  };

  getAuthorizedSelectedTeamMentorIds = () => {
    let teamMentorIds = Object.keys(
      this.state.selectedTeamMentorDtos ?? {},
    ).filter((teamMentorId) => {
      const teamWidgetDto = this.state.selectedTeamMentorDtos[teamMentorId];
      const role = expertHomeService.getWidgetAdminRole(
        teamWidgetDto,
        this.context.currentUser.userId,
      );
      return (
        teamWidgetDto.widgetAppCtrlDto.widgetPrivacyMode !==
          VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_PRIVATE &&
        [
          VIDABOO_CONSTANTS.WIDGET_ADMIN_ROLES.ADMIN,
          VIDABOO_CONSTANTS.WIDGET_ADMIN_ROLES.READ_PRIVATE,
        ].includes(role)
      );
    });
    return teamMentorIds;
  };

  getSelectedTeamMentorIds = () => {
    return Object.keys(this.state.selectedTeamMentorDtos || {});
  };

  getUnAuthorizedUserDtos = (usersCtrlMap) => {
    let userDtos = [];
    const selectedMentorDtos = this.state.selectedMentorDtos || {};
    for (const mentorId in selectedMentorDtos) {
      if (
        selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
          .extendedMentorDto.privateDataConsentStatus ===
        VIDABOO_CONSTANTS.PRIVATE_DATA_ACCESS_STATES.REQUEST
      ) {
        const userDto =
          usersCtrlMap[
            selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
              .extendedMentorDto.mentorDto.mentorOwnerId
          ]?.userDto;
        if (userDto && !userDtos.includes(userDto)) {
          userDtos.push(userDto);
        }
      }
    }
    return userDtos;
  };

  setRootNavElement = (rootNavElement) => {
    this.setState({rootNavElement});
    navigationService.setRootNavElement(this.setRootNavElement);
  };

  setShowMentorPills = (showMentorPills) => {
    this.setState({showMentorPills});
  };

  setShowWidgetSelectorDD = (showWidgetSelectorDD) => {
    this.setState({showWidgetSelectorDD});
  };

  setBackOfficeConfiguration = (backOfficeConfiguration) => {
    this.setState({backOfficeConfiguration});
  };

  setShowFullBackOfficeSettingsBtn = (showFullBackOfficeSettingsBtn) => {
    this.setState({showFullBackOfficeSettingsBtn});
  };

  setExpertSettingsTabMode = (expertSettingsTabMode) => {
    this.setState({expertSettingsTabMode});
  };

  setActiveNavElementByUrl = (url) => {
    const navElement = navigationService.getNavElementUsingUrl(url);
    if (navElement) {
      if (navElement.tabMode) {
        this.setExpertSettingsTabMode(navElement.tabMode);
      }
      this.setActiveNavElement(navElement);
    }
  };

  resetExpertHomeContextAndRootNav = () => {
    const navData = [
      {
        url: 'home',
        isViewable: true,
      },
      {
        url: 'widgetSetup',
        isViewable: true,
      },
      {
        url: 'personalSettings',
        isViewable: true,
      },
      {
        url: 'accountSettings',
        isViewable: true,
      },
      {
        url: 'settingsShortcuts',
        isViewable: true,
      },
    ];
    navigationService.updateNavElementsIsViewable(navData);
    //eslint-disable-next-line react/no-direct-mutation-state
    this.setState({
      privateChatRoomDto: {},
      chatRoomIdOfActiveCall: null,
      userProfilePhotoUrl: null,
      accountProfilePhotoUrl: null,
      widgetDtos: null,
      selectedMentorDtos: null,
      rootNavElement: null,
      activeNavElement: null,
      showMentorPills: false,
      showWidgetSelectorDD: false,
      backOfficeConfiguration: null,
      expertSettingsTabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
      avoidFrillAutoload: false,
      activeTourComponent: false,
      setMarketingElementsStatus:
        expertHomeService.createNewMarketingElementsStatus(),
    });
  };

  updateDataWhenWidgetDtosChanged = (updatedWidgetDtos) => {
    //this updates the widgetDto of selectedMentorDtos and selectedTeamMentorDtos of expertHomeContext whenever there is change in widgetDtos (for eg due to API)
    let tmpSelectedMentorDtosObj = JSON.parse(
      JSON.stringify(this.state.selectedMentorDtos || {}),
    );
    // let tmpSelectedTeamMentorDtosObj = JSON.parse(
    //   JSON.stringify(this.state.selectedTeamMentorDtos || {}),
    // );

    ({
      updatedWidgetDtos,
      tmpSelectedMentorDtosObj,
      // tmpSelectedTeamMentorDtosObj,
    } = expertHomeService.updateDataWhenWidgetDtosChanged(
      updatedWidgetDtos,
      tmpSelectedMentorDtosObj,
      // tmpSelectedTeamMentorDtosObj,
      this.context.accountDto,
      this.context.currentUser.userId,
    ));

    // we need to update selectedMentorDtos in few cases like:
    // 1. when account admin deletes the mentor which was selected by team admin in his account. But after deletion it doesn't exist anymore so we need to update the selectedMentorDtos
    // 2. if widgetPrivacyMode is changed (currently team mentor was selected and mentor moved to FULLY PRIVATE)
    const selectedMentorDto = expertHomeService.getSelectedMentorDto(
      tmpSelectedMentorDtosObj,
    );
    const selectedWidgetDto = expertHomeService.getSelectedWidgetDto(
      tmpSelectedMentorDtosObj,
    );
    if (
      selectedMentorDto.mentorOwnerType ===
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET &&
      selectedWidgetDto.widgetAppCtrlDto?.widgetPrivacyMode ===
        VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_PRIVATE
    ) {
      delete tmpSelectedMentorDtosObj[selectedMentorDto.mentorId];
    }
    if (Object.keys(tmpSelectedMentorDtosObj).length === 0) {
      const defaultSelectedMentorId = Object.keys(
        updatedWidgetDtos[0].mentorsControlMapDto ??
          updatedWidgetDtos[0].teamMentorsMap,
      )[0];
      tmpSelectedMentorDtosObj[defaultSelectedMentorId] = updatedWidgetDtos[0];
    }

    this.setWidgetSelectedMentorAndTeamMentorDtos(
      updatedWidgetDtos,
      // tmpSelectedTeamMentorDtosObj,
      tmpSelectedMentorDtosObj,
    );
  };

  // updateDataWhenSelectedTeamMentorDtosChanged = (
  //   updatedSelectedTeamMentorDtosObj,
  // ) => {
  // //this updates the widgetDtos and selectedMentorDtos of expertHomeContext whenever there is change in selectedTeamMentorDtos (for eg due to API)
  // let tmpWidgetDtosArr = JSON.parse(
  //   JSON.stringify(this.state.widgetDtos || []),
  // );
  // let tmpSelectedMentorDtosObj = JSON.parse(
  //   JSON.stringify(this.state.selectedMentorDtos || {}),
  // );
  // ({
  //   updatedSelectedTeamMentorDtosObj,
  //   tmpWidgetDtosArr,
  //   tmpSelectedMentorDtosObj,
  // } = expertHomeService.updateDataWhenSelectedTeamMentorDtosChanged(
  //   updatedSelectedTeamMentorDtosObj,
  //   tmpWidgetDtosArr,
  //   tmpSelectedMentorDtosObj,
  //   this.context.accountDto,
  //   this.context.currentUser.userId,
  // ));
  // this.setWidgetSelectedMentorAndTeamMentorDtos(
  //   tmpWidgetDtosArr,
  //   updatedSelectedTeamMentorDtosObj,
  //   tmpSelectedMentorDtosObj,
  // );
  // };

  updateDataWhenSelectedMentorDtosChanged = (updatedSelectedMentorDtosObj) => {
    //this updates the widgetDtos and selectedTeamMentorDtos of expertHomeContext whenever there is change in selectedMentorDtos (for eg due to API)
    let tmpWidgetDtosArr = JSON.parse(
      JSON.stringify(this.state.widgetDtos || []),
    );
    // let tmpSelectedTeamMentorDtosObj = JSON.parse(
    //   JSON.stringify(this.state.selectedTeamMentorDtos || {}),
    // );

    expertHomeService.updateDataWhenSelectedMentorDtosChanged(
      updatedSelectedMentorDtosObj,
      tmpWidgetDtosArr,
      // tmpSelectedTeamMentorDtosObj,
      this.context.accountDto,
      this.context.currentUser.userId,
    );

    this.setWidgetSelectedMentorAndTeamMentorDtos(
      tmpWidgetDtosArr,
      // tmpSelectedTeamMentorDtosObj,
      updatedSelectedMentorDtosObj,
    );
  };

  setWidgetSelectedMentorAndTeamMentorDtos = (
    widgetDtos,
    // selectedTeamMentorDtos,
    selectedMentorDtos,
  ) => {
    this.setState({
      widgetDtos,
      // selectedTeamMentorDtos,
      selectedMentorDtos,
    });
  };

  render() {
    let {
      state: {
        nativeFlagWidgetVisibilityType,
        activeNavElement,
        privateChatRoomDto,
        chatRoomIdOfActiveCall,
        rootNavElement,
        selectedMentorDtos,
        // selectedTeamMentorDtos,
        userProfilePhotoUrl,
        accountProfilePhotoUrl,
        widgetDtos,
        showMentorPills,
        showWidgetSelectorDD,
        backOfficeConfiguration,
        expertSettingsTabMode,
        avoidFrillAutoload,
        showFullBackOfficeSettingsBtn,
        activeTourComponent,
        marketingElementsStatus,
      },
      setActiveNavElement,
      setPrivateChatRoomDto,
      setChatRoomIdOfActiveCall,
      setRootNavElement,
      setSelectedMentorDtos,
      // setSelectedTeamMentorDtos,
      setUserProfilePhotoUrl,
      setAccountProfilePhotoUrl,
      setWidgetDtos,
      setShowMentorPills,
      setShowWidgetSelectorDD,
      setBackOfficeConfiguration,
      setExpertSettingsTabMode,
      setActiveNavElementByUrl,
      setNativeFlagWidgetVisibility,
      resetExpertHomeContextAndRootNav,
      setAvoidFrillAutoload,
      setShowFullBackOfficeSettingsBtn,
      setActiveTourComponent,
      setMarketingElementsStatus,
      updateDataWhenSelectedMentorDtosChanged,
      // updateDataWhenSelectedTeamMentorDtosChanged,
      updateDataWhenWidgetDtosChanged,
    } = this;

    return (
      <ThisContext.Provider
        value={{
          nativeFlagWidgetVisibilityType,
          activeNavElement,
          privateChatRoomDto,
          chatRoomIdOfActiveCall,
          rootNavElement,
          selectedMentorDtos, // [{mentorId: widgetDto}]
          // selectedTeamMentorDtos,
          userProfilePhotoUrl,
          accountProfilePhotoUrl,
          widgetDtos,
          showMentorPills,
          showWidgetSelectorDD,
          backOfficeConfiguration,
          expertSettingsTabMode,
          avoidFrillAutoload,
          showFullBackOfficeSettingsBtn,
          activeTourComponent,
          marketingElementsStatus,
          setActiveNavElement,
          setPrivateChatRoomDto,
          setChatRoomIdOfActiveCall,
          setRootNavElement,
          setSelectedMentorDtos,
          // setSelectedTeamMentorDtos,
          setUserProfilePhotoUrl,
          setAccountProfilePhotoUrl,
          setWidgetDtos,
          setShowMentorPills,
          setShowWidgetSelectorDD,
          setBackOfficeConfiguration,
          setExpertSettingsTabMode,
          setActiveNavElementByUrl,
          resetExpertHomeContextAndRootNav,
          setAvoidFrillAutoload,
          setShowFullBackOfficeSettingsBtn,
          setActiveTourComponent,
          setMarketingElementsStatus,
          setNativeFlagWidgetVisibility,
          updateDataWhenSelectedMentorDtosChanged,
          // updateDataWhenSelectedTeamMentorDtosChanged,
          updateDataWhenWidgetDtosChanged,
        }}>
        {this.props.children}
      </ThisContext.Provider>
    );
  }
}

ExpertHomeContextProvider.contextType = AppContext;
export default ExpertHomeContextProvider;

export const withExpertHomeContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <ThisContext.Consumer>
      {(context) => (
        <Component expertHomeContext={context} {...props} ref={ref} />
      )}
    </ThisContext.Consumer>
  ));
